import React from "react";
import StoryAuthorName from "./StoryAuthorName";

export default function StoryAuthorsName({ multipleAuthors }) {
  return (
    <a style={{ textAlign: "center", display: "inline-flex" }}>
      {multipleAuthors.map((author, i) => {
        if (i == multipleAuthors.length - 1) {
          if (i == 1) {
            return (
              <StoryAuthorName authorSlug={author["slug"]} connector=" and ">
                {author["fullName"]}
              </StoryAuthorName>
            );
          } else {
            return (
              <StoryAuthorName authorSlug={author["slug"]} connector=", and ">
                {author["fullName"]}
              </StoryAuthorName>
            );
          }
        } else if (i == 0) {
          return (
            <StoryAuthorName authorSlug={author["slug"]} connector="">
              {author["fullName"]}
            </StoryAuthorName>
          );
        } else {
          return (
            <StoryAuthorName authorSlug={author["slug"]} connector=", ">
              {author["fullName"]}
            </StoryAuthorName>
          );
        }
      })}
    </a>
  );
}
